import ReactDOM from 'react-dom';
export var findDOMNode = ReactDOM.findDOMNode || ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE.findDOMNode;